import { Fragment, useContext } from "react";
import { BsCheckCircle, BsSafe, BsXLg } from "react-icons/bs";
import { ReactComponent as Ticket } from "assets/sidebar-icons/ticket.svg";
import RowData from "./components/row-data.component";
import { ClientsContext } from "src/contexts/clients.context";

import "./row.style.scss";

// {
// 		company: { name: "Spotify", img: "", color: "#78EB65" },
// 		id: "010929",
// 		filler: { done: 0, message: 0, invoices: 0 },
// }

const Row = ({ row, index, extraData = [], isExpanded = false, onClick, onDelete }) => {
	const { clients } = useContext(ClientsContext);

	let color = 0,
		name = "",
		surname = "",
		id = "",
		done = "",
		message = "",
		invoices = "";

	if (row.companyType === 0) {
		({
			name,
			surname,
			color,
			id,
			filler: { done, message, invoices },
		} = row);
	} else {
		({
			company: { name, color },
			id,
			filler: { done, message, invoices },
		} = row);
	}

	if (clients.length <= index) return null;

	return (
		<Fragment>
			<tr className={`size400 w400 row-title unselectable ${isExpanded && "expanded-title"}`}>
				<td onClick={onClick}>
					<span style={{ backgroundColor: color }} className="img-box" />{" "}
					<span className="w600">{surname.length > 0 ? name + " " + surname : name} </span>
				</td>
				<td onClick={onClick}>{id}</td>
				<td onClick={onClick} className="fillers">
					<span className="size300 w600 filler-item">
						<BsCheckCircle className="icon" />
						<span>{done > 99 ? "99+" : done}</span>
					</span>
					<span className="size300 w600 filler-item">
						<Ticket className="icon" />
						<span>{message > 99 ? "99+" : message}</span>
					</span>
					<span className="size300 w600 filler-item">
						<BsSafe className="icon" />
						<span>{invoices > 99 ? "99+" : invoices}</span>
					</span>
				</td>
				{onDelete && (
					<td>
						<BsXLg onClick={onDelete} size={12} style={{ zIndex: 10 }} />
					</td>
				)}
			</tr>
			{extraData.length > 0 && (
				<tr className={`row-data ${isExpanded && "expanded"}`}>
					<td>
						<RowData index={index} data={row} />
					</td>
					{/* <td style={{ backgroundColor: "pink" }}></td> */}
				</tr>
			)}
		</Fragment>
	);
};

export default Row;
